"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Remarkable = require('remarkable');

var md = new Remarkable.Remarkable();
md.inline.ruler.enable(['sup', 'sub']);

exports.MarkdownRenderer = function (_a) {
  var content = _a.content;
  return react_1["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: md.render(content)
    }
  });
};